var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrdersuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 252.6H259.62C261.516 250.452 263.754 246.894 264.306 246.156C269.83 238.691 274.42 230.579 277.974 222C292.542 187.092 289.974 146.508 274.68 112.2C263.34 86.808 243.516 64.89 215.634 53.964C189.912 43.878 154.434 41.262 132.588 59.964C110.742 78.666 114.33 111.69 92.388 130.386C91.788 130.908 91.146 131.412 90.504 131.898C78.552 140.862 62.112 140.67 47.904 144.354C33.162 148.182 19.632 157.752 14.514 171.354C7.75196 189.354 13.866 209.958 24.318 225.678C37.068 244.848 56.514 250.32 78 252.6Z",
    fill: "#5D94E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78 252.6H259.62C261.516 250.452 263.754 246.894 264.306 246.156C269.83 238.691 274.42 230.579 277.974 222C292.542 187.092 289.974 146.508 274.68 112.2C263.34 86.808 243.516 64.89 215.634 53.964C189.912 43.878 154.434 41.262 132.588 59.964C110.742 78.666 114.33 111.69 92.388 130.386C91.788 130.908 91.146 131.412 90.504 131.898C78.552 140.862 62.112 140.67 47.904 144.354C33.162 148.182 19.632 157.752 14.514 171.354C7.75196 189.354 13.866 209.958 24.318 225.678C37.068 244.848 56.514 250.32 78 252.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 47.3999H132.414L131.496 56.9579H201.954V47.3999Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 56.958H132.414L131.496 66.522H201.954V56.958Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 66.522H132.414L131.496 76.08H201.954V66.522Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 76.0801H132.414L131.496 85.6381H201.954V76.0801Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 85.6382H132.414L131.496 95.2022H201.954V85.6382Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 95.2021H132.414L131.496 104.76H201.954V95.2021Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 104.76H132.414L131.496 114.318H201.954V104.76Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 114.318H132.414L131.496 123.882H201.954V114.318Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 123.882H132.414L131.496 133.44H201.954V123.882Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 133.44H132.414L131.496 142.998H201.954V133.44Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 142.998H132.414L131.496 152.562H201.954V142.998Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 152.562H132.414L131.496 162.12H201.954V152.562Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 162.12H132.414L131.496 171.678H201.954V162.12Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 171.678H132.414L131.496 181.242H201.954V171.678Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.954 181.242H132.414L131.496 190.8H201.954V181.242Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 47.3999H203.898L202.98 56.9579H273.432V47.3999Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 56.958H203.898L202.98 66.522H273.432V56.958Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 66.522H203.898L202.98 76.08H273.432V66.522Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 76.0801H203.898L202.98 85.6381H273.432V76.0801Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 85.6382H203.898L202.98 95.2022H273.432V85.6382Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 95.2021H203.898L202.98 104.76H273.432V95.2021Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 104.76H203.898L202.98 114.318H273.432V104.76Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 114.318H203.898L202.98 123.882H273.432V114.318Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 123.882H203.898L202.98 133.44H273.432V123.882Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 133.44H203.898L202.98 142.998H273.432V133.44Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 142.998H203.898L202.98 152.562H273.432V142.998Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 152.562H203.898L202.98 162.12H273.432V152.562Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 162.12H203.898L202.98 171.678H273.432V162.12Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 171.678H203.898L202.98 181.242H273.432V171.678Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M273.432 181.242H203.898L202.98 190.8H273.432V181.242Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M276.918 39.9961H129.87V47.2081H276.918V39.9961Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M276.918 47.208V174.222",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M275.316 47.4121V134.556",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M277.956 173.94H275.982V177.174H277.956V173.94Z",
    fill: "#263238",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M276.18 133.86H274.2V137.094H276.18V133.86Z",
    fill: "#263238",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.4 53.3999H28.8V147.6H104.4V53.3999Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M102.474 55.7998H30.7261V145.2H102.474V55.7998Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8001 84.0537H53.4001V116.952H79.8001V84.0537Z",
    fill: "#D6D6D6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2001 238.2C91.2001 238.2 91.4701 228.546 91.1281 220.242C90.7861 211.938 91.4761 194.13 91.4761 194.13",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M91.314 204.612L87.54 201.648",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2781 206.658L92.6161 204.486",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9661 215.244L94.3201 212.478",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4761 197.79L89.7061 196.182",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9362 216.756L88.7222 214.38",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1341 226.074L86.5261 221.874",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M91.248 231.252C92.4239 230.802 93.5667 230.271 94.668 229.662",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M88.71 206.106C86.856 204.672 80.652 204.906 79.452 207.906C78.252 210.906 82.038 215.706 85.698 215.376C87.126 215.244 87.744 215.142 88.302 214.344L83.202 209.358L88.722 213.792C88.882 213.505 89.0088 213.201 89.1 212.886C89.166 212.664 89.22 212.43 89.274 212.178C89.628 210.396 90.438 207.444 88.71 206.106Z",
    fill: "#31D490"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M100.71 202.662C100.712 202.696 100.712 202.73 100.71 202.764C100.212 204.978 97.68 206.232 95.55 206.046C95.2539 206.017 94.9609 205.962 94.674 205.884C94.1772 206.677 93.8696 207.574 93.775 208.505C93.6803 209.436 93.8011 210.377 94.128 211.254C94.2189 211.501 94.3398 211.737 94.488 211.956C95.088 211.446 101.826 205.716 101.826 205.716L94.86 212.43C96.954 214.68 101.886 214.374 103.602 210.204C105.318 206.034 103.128 203.256 100.71 202.662Z",
    fill: "#00B368"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2961 194.916C93.6961 194.118 90.4501 195.762 90.5101 199.53C90.5242 200.365 90.7099 201.189 91.0556 201.95C91.4014 202.71 91.8999 203.392 92.5201 203.952L96.2041 198.84L93.0721 204.378C93.3668 204.576 93.6803 204.745 94.0081 204.882C94.466 205.068 94.9495 205.183 95.4421 205.224C97.5661 205.41 100.098 204.156 100.602 201.942C101.16 199.464 100.908 195.708 97.2961 194.916Z",
    fill: "#31D490"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0781 181.8C92.1633 182.167 91.2681 182.582 90.3961 183.042C88.0861 184.17 86.2621 187.842 88.0861 190.956C88.7241 192.226 89.8328 193.197 91.1761 193.662L92.1001 184.662L91.7281 193.8C91.9035 193.819 92.0806 193.819 92.2561 193.8C93.7561 193.644 96.1321 191.85 96.3601 188.166C96.5881 184.482 93.0781 181.8 93.0781 181.8Z",
    fill: "#00B368"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5242 189.972L89.4962 195.546C89.5718 195.291 89.5943 195.023 89.5622 194.76C89.2442 191.568 86.0582 189.72 83.9522 189.054C81.8462 188.388 80.3942 189.576 81.7442 192.654C83.0942 195.732 86.6462 197.166 88.2302 196.722C88.6064 196.63 88.943 196.42 89.1902 196.122L82.5242 189.972Z",
    fill: "#31D490"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3241 197.118C85.8181 197.166 83.3821 196.092 81.9601 194.022C81.2245 193.959 80.4931 194.184 79.9201 194.649C79.3471 195.115 78.9771 195.785 78.8881 196.518C78.1801 199.848 80.5861 203.328 84.0541 202.902C85.1326 202.844 86.1563 202.408 86.9461 201.672L80.7421 196.014L87.3781 201.072C87.5099 200.834 87.5935 200.573 87.6241 200.304C87.8394 199.235 87.7351 198.127 87.3241 197.118Z",
    fill: "#00B368"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2881 215.61C86.7175 215.856 86.1083 216 85.4881 216.036C83.2201 216.246 80.9101 214.47 79.7581 212.382C78.3661 212.61 77.2561 213.354 76.9861 214.878C76.3021 218.772 79.9021 223.878 83.5441 223.092C84.4912 222.905 85.3678 222.458 86.0761 221.802L78.1261 214.158L86.5261 221.286C87.0077 220.669 87.3182 219.937 87.4261 219.162C87.8279 218.003 87.7786 216.734 87.2881 215.61Z",
    fill: "#00B368"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M103.278 223.596C100.608 220.506 97.422 223.272 97.422 223.272C97.422 223.272 95.472 223.92 94.74 226.68C94.5068 227.519 94.5403 228.41 94.836 229.23L102.876 224.544L95.028 229.668C95.76 231.054 97.356 231.906 99.546 231.288C103.086 230.298 105.954 226.692 103.278 223.596Z",
    fill: "#31D490"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M96.618 235.296H85.488V251.778H96.618V235.296Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M183.354 187.308L182.922 183.972C182.454 180.792 181.242 172.464 181.242 171.66C181.242 170.67 176.646 167.814 176.646 167.814L171.114 175.686L167.316 183.096C167.316 183.096 169.758 185.31 171.924 186.936C173.339 187.952 174.945 188.671 176.646 189.048L187.716 227.016L195.162 211.968L183.354 187.308Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.275 156.187L165.316 156.579C163.675 156.66 162.409 158.056 162.49 159.697L163.549 181.199C163.63 182.841 165.027 184.106 166.668 184.025L174.626 183.633C176.268 183.553 177.533 182.156 177.452 180.515L176.393 159.013C176.312 157.371 174.916 156.106 173.275 156.187Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M174.146 156.12L166.188 156.512C164.546 156.593 163.281 157.989 163.362 159.631L164.421 181.133C164.502 182.774 165.898 184.039 167.54 183.959L175.498 183.566C177.14 183.486 178.405 182.089 178.324 180.448L177.265 158.946C177.184 157.304 175.788 156.039 174.146 156.12Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M176.85 159.888C176.813 159.216 176.55 158.576 176.105 158.071C175.66 157.566 175.058 157.226 174.396 157.104L173.442 158.4L167.982 158.742L166.278 157.602L173.772 157.086H173.73L166.686 157.434C165.9 157.479 165.163 157.832 164.634 158.416C164.105 158.999 163.827 159.768 163.86 160.554L164.832 180.246C164.877 181.033 165.229 181.77 165.813 182.299C166.397 182.827 167.165 183.105 167.952 183.072L174.99 182.724C175.776 182.679 176.513 182.327 177.042 181.743C177.571 181.16 177.849 180.391 177.816 179.604L176.85 159.888Z",
    fill: "#5D94E7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M180.696 187.98C179.64 187.846 178.658 187.365 177.906 186.613C177.153 185.86 176.672 184.878 176.538 183.822C175.992 180.024 177.804 175.686 177.804 175.686C176.591 174.981 175.32 174.379 174.006 173.886C172.014 173.16 173.46 169.362 174.186 170.448C174.912 171.534 179.97 172.248 181.416 173.16C182.862 174.072 183.216 179.31 183.216 179.31L183.342 187.314",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M180.696 187.98C179.64 187.846 178.658 187.365 177.906 186.613C177.153 185.86 176.672 184.878 176.538 183.822C175.992 180.024 177.804 175.686 177.804 175.686C176.591 174.981 175.32 174.379 174.006 173.886C172.014 173.16 173.46 169.362 174.186 170.448C174.912 171.534 179.97 172.248 181.416 173.16C182.862 174.072 183.216 179.31 183.216 179.31L183.342 187.314",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M233.256 252.6L251.4 205.056C252.124 203.161 252.085 201.059 251.292 199.192C250.499 197.324 249.013 195.837 247.146 195.042C245.243 194.234 243.098 194.209 241.177 194.973C239.256 195.737 237.714 197.228 236.886 199.122L213.564 252.6H233.256Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M187.602 231C186.894 231.534 172.536 248.688 169.266 252.6H211.2C213.726 249.09 223.866 234.714 228.222 224.598C233.226 213 233.622 199.2 232.626 195C231.63 190.8 230.622 187.8 230.622 187.8C230.622 187.8 211.2 191.202 201 196.602C201 196.602 188.598 206.202 186.198 212.4C183.798 218.598 188.4 230.4 187.602 231Z",
    fill: "#5D94E7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M221.952 224.034C222.414 222.834 222.846 221.634 223.242 220.434C225.096 214.77 227.442 207.942 226.2 201.942C225 196.14 217.602 196.74 213.402 199.938C209.202 203.136 206.202 210.738 204.402 217.338C202.602 223.938 194.964 239.01 194.964 239.01C194.964 239.01 167.562 233.208 164.364 232.008C161.166 230.808 156.762 228.81 153.762 226.008C150.762 223.206 142.764 219.006 139.962 215.808C137.16 212.61 136.764 213.606 136.962 214.806C137.16 216.006 138.564 217.41 139.56 218.61C140.506 219.663 141.507 220.664 142.56 221.61C142.56 221.61 137.964 220.608 135.762 219.81C133.56 219.012 132.564 217.806 131.964 218.808C131.364 219.81 131.964 221.01 133.962 222.006C135.96 223.002 143.76 225.21 143.76 225.21H135.762C134.16 225.21 131.964 226.206 132.96 227.208C133.956 228.21 138.96 227.61 140.364 227.61H144.564C144.564 227.61 138.96 229.608 137.364 229.806C135.768 230.004 135.96 231.606 137.16 231.81C138.36 232.014 146.964 230.208 146.964 230.208C146.964 230.208 150.564 233.01 152.16 233.406C153.612 233.677 155.087 233.812 156.564 233.808C156.564 233.808 170.964 243.408 181.764 247.206C189.186 249.822 203.034 257.052 208.926 248.712C213.108 242.784 219.36 230.754 221.952 224.034Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M216.81 138.132C216.81 138.132 212.526 143.7 212.094 146.7C211.662 149.7 212.31 151.41 210.81 152.268C209.31 153.126 204.81 153.12 204.174 155.268C203.538 157.416 206.526 161.268 206.526 161.268C206.526 161.268 206.958 170.904 207.816 173.04C208.674 175.176 216.378 175.614 216.378 175.614L215.094 184.8L227.73 180.948L231.156 168.528C231.156 168.528 236.082 166.386 237.792 159.528C239.502 152.67 236.508 145.608 229.014 141.114C221.52 136.62 216.81 138.132 216.81 138.132Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M216.378 175.608L222.804 176.274L215.946 179.892L216.378 175.608Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M209.742 162.546C209.742 162.546 213.81 163.188 215.952 160.404",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M215.34 151.674C215.022 152.466 214.392 152.964 213.93 152.778C213.468 152.592 213.33 151.8 213.672 151.008C214.014 150.216 214.626 149.712 215.082 149.898C215.538 150.084 215.658 150.876 215.34 151.674Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M214.836 145.8C214.836 145.8 217.2 144.33 218.754 147.27",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M211.158 162.69C211.158 162.69 211.08 166.032 212.304 165.954C213.528 165.876 214.998 161.46 214.998 161.46C214.998 161.46 214.098 162.522 211.158 162.69Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M229.998 179.4C229.998 179.4 214.002 185.4 209.202 187.002C204.402 188.604 199.602 198.402 199.602 198.402C199.602 198.402 223.398 190.398 227.802 189.198L231.198 188.802C231.198 188.802 232.2 180.6 229.998 179.4Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M239.604 128.484C239.604 128.484 239.04 128.766 241.02 124.53C243 120.294 233.382 116.328 222.36 119.73C211.338 123.132 212.76 132.174 214.158 136.416C215.556 140.658 223.758 139.806 223.488 142.632C223.218 145.458 221.508 148.29 224.622 150.834C227.736 153.378 225.186 152.814 226.032 154.23C226.878 155.646 229.71 154.794 230.556 155.358C231.402 155.922 233.664 157.902 231.12 161.862C228.576 165.822 225.75 165.252 226.32 169.776C226.89 174.3 228.018 178.542 233.958 180.24C239.898 181.938 244.98 182.22 245.832 177.414C246.684 172.608 243.57 171.474 246.96 169.494C250.35 167.514 259.686 166.668 260.814 157.338C261.942 148.008 259.68 139.512 253.2 134.142C249.339 130.933 244.602 128.961 239.604 128.484Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M234.39 175.152C235.836 177.726 238.758 178.842 240.39 178.242C242.79 177.33 243.114 172.788 240.084 172.182C237.054 171.576 236.148 173.382 237.684 174.906",
    stroke: "#9C9C9C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M222.87 135.324C224.388 137.724 228.072 139.302 234.606 141.282C244.602 144.312 247.026 152.19 244.602 156.126C242.178 160.062 234.906 164.004 233.694 170.058C233.502 170.988 233.471 171.944 233.604 172.884",
    stroke: "#9C9C9C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M230.058 129.168C230.058 129.168 233.694 128.862 231.858 125.832C230.022 122.802 223.074 125.232 222.168 130.68C222.006 131.523 221.98 132.385 222.09 133.236",
    stroke: "#9C9C9C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M245.082 140.118C248.208 141.768 252.03 144.996 252.474 150.978C253.074 159.156 249.444 161.88 243.39 165.516C237.336 169.152 240.054 172.2 240.054 172.2",
    stroke: "#9C9C9C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M240.966 138.558C241.786 138.746 242.589 139.003 243.366 139.326",
    stroke: "#9C9C9C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M161.67 68.5859C157.139 69.9488 153.009 72.3953 149.636 75.7135C146.264 79.0318 143.75 83.1219 142.314 87.6299",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M176.088 68.016C174.088 67.5883 172.049 67.3731 170.004 67.374C168.637 67.3755 167.272 67.4717 165.918 67.662",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M197.742 105.048C199.97 97.8529 199.32 90.0744 195.929 83.3488C192.539 76.6233 186.671 71.4752 179.562 68.9878",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M195.06 111.114C195.862 109.753 196.55 108.328 197.118 106.854",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M157.848 122.808C163.118 125.231 168.993 126.022 174.717 125.079C180.441 124.136 185.751 121.502 189.966 117.516",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M153.246 120.144C154.104 120.749 154.994 121.31 155.91 121.824",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M141.33 91.7998C140.536 96.7316 141.027 101.785 142.756 106.471C144.485 111.158 147.393 115.319 151.2 118.554",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M170.004 122.7C184.518 122.7 196.284 110.934 196.284 96.4201C196.284 81.9061 184.518 70.1401 170.004 70.1401C155.49 70.1401 143.724 81.9061 143.724 96.4201C143.724 110.934 155.49 122.7 170.004 122.7Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M186.162 113.856H156.918C156.516 113.856 156.127 113.711 155.823 113.448C155.519 113.184 155.32 112.82 155.262 112.422L150.066 78.5582H143.562C143.12 78.5582 142.695 78.3824 142.383 78.0696C142.07 77.7568 141.894 77.3325 141.894 76.8902C141.894 76.4478 142.07 76.0235 142.383 75.7107C142.695 75.3979 143.12 75.2222 143.562 75.2222H151.512C151.914 75.2225 152.302 75.3678 152.605 75.6312C152.908 75.8946 153.106 76.2586 153.162 76.6562L158.364 110.52H186.162C186.604 110.52 187.029 110.696 187.341 111.009C187.654 111.322 187.83 111.746 187.83 112.188C187.83 112.631 187.654 113.055 187.341 113.368C187.029 113.68 186.604 113.856 186.162 113.856Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M144.216 74.7959H141.486C140.379 74.7959 139.482 75.6931 139.482 76.7999V77.0399C139.482 78.1467 140.379 79.0439 141.486 79.0439H144.216C145.323 79.0439 146.22 78.1467 146.22 77.0399V76.7999C146.22 75.6931 145.323 74.7959 144.216 74.7959Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M154.416 106.818H157.674L157.302 104.436H154.038L154.416 106.818Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M185.574 105.186H153.69L150.876 83.25H188.388L185.574 105.186Z",
    fill: "#5D94E7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M161.646 102.798C161.436 102.798 161.229 102.757 161.035 102.676C160.842 102.596 160.666 102.479 160.517 102.331C160.369 102.182 160.252 102.006 160.172 101.813C160.091 101.619 160.05 101.412 160.05 101.202V90.144C160.05 89.7202 160.218 89.3136 160.517 89.0133C160.816 88.7131 161.222 88.5436 161.646 88.542C162.07 88.5436 162.476 88.7131 162.775 89.0133C163.074 89.3136 163.242 89.7202 163.242 90.144V101.202C163.242 101.412 163.201 101.619 163.121 101.813C163.04 102.006 162.923 102.182 162.775 102.331C162.626 102.479 162.45 102.596 162.257 102.676C162.063 102.757 161.856 102.798 161.646 102.798Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M167.298 102.798C166.875 102.798 166.469 102.63 166.169 102.331C165.87 102.031 165.702 101.625 165.702 101.202V90.144C165.702 89.7202 165.87 89.3136 166.169 89.0133C166.468 88.7131 166.874 88.5436 167.298 88.542C167.722 88.5436 168.128 88.7131 168.427 89.0133C168.726 89.3136 168.894 89.7202 168.894 90.144V101.202C168.894 101.625 168.726 102.031 168.426 102.331C168.127 102.63 167.721 102.798 167.298 102.798Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M172.95 102.798C172.74 102.798 172.533 102.757 172.339 102.676C172.146 102.596 171.97 102.479 171.821 102.331C171.673 102.182 171.556 102.006 171.475 101.813C171.395 101.619 171.354 101.412 171.354 101.202V90.144C171.354 89.7202 171.522 89.3136 171.821 89.0133C172.12 88.7131 172.526 88.5436 172.95 88.542C173.374 88.5436 173.78 88.7131 174.079 89.0133C174.378 89.3136 174.546 89.7202 174.546 90.144V101.202C174.546 101.412 174.505 101.619 174.425 101.813C174.344 102.006 174.227 102.182 174.079 102.331C173.93 102.479 173.754 102.596 173.561 102.676C173.367 102.757 173.16 102.798 172.95 102.798Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M178.602 102.798C178.179 102.798 177.773 102.63 177.473 102.331C177.174 102.031 177.006 101.625 177.006 101.202V90.144C177.006 89.7202 177.174 89.3136 177.473 89.0133C177.772 88.7131 178.178 88.5436 178.602 88.542C179.026 88.5436 179.432 88.7131 179.731 89.0133C180.03 89.3136 180.198 89.7202 180.198 90.144V101.202C180.198 101.625 180.03 102.031 179.73 102.331C179.431 102.63 179.025 102.798 178.602 102.798Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M163.806 117.63C165.976 117.63 167.736 115.871 167.736 113.7C167.736 111.53 165.976 109.77 163.806 109.77C161.636 109.77 159.876 111.53 159.876 113.7C159.876 115.871 161.636 117.63 163.806 117.63Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M163.806 115.386C164.737 115.386 165.492 114.631 165.492 113.7C165.492 112.769 164.737 112.014 163.806 112.014C162.875 112.014 162.12 112.769 162.12 113.7C162.12 114.631 162.875 115.386 163.806 115.386Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M177.108 117.63C179.278 117.63 181.038 115.871 181.038 113.7C181.038 111.53 179.278 109.77 177.108 109.77C174.937 109.77 173.178 111.53 173.178 113.7C173.178 115.871 174.937 117.63 177.108 117.63Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M178.8 113.7C178.8 113.367 178.701 113.041 178.516 112.763C178.331 112.486 178.067 112.27 177.759 112.143C177.451 112.015 177.112 111.982 176.785 112.047C176.458 112.112 176.158 112.272 175.922 112.508C175.686 112.744 175.525 113.044 175.46 113.371C175.395 113.698 175.429 114.037 175.556 114.345C175.684 114.653 175.9 114.917 176.177 115.102C176.455 115.287 176.781 115.386 177.114 115.386C177.336 115.387 177.555 115.344 177.76 115.259C177.965 115.175 178.151 115.051 178.308 114.894C178.465 114.737 178.589 114.551 178.673 114.346C178.758 114.141 178.801 113.922 178.8 113.7Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M184.176 86.8262H187.644",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M179.832 86.8262H182.292",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M151.764 86.8262H177.948",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M170.004 122.7V153.594",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M170.004 155.268C170.928 155.268 171.678 154.518 171.678 153.594C171.678 152.669 170.928 151.92 170.004 151.92C169.079 151.92 168.33 152.669 168.33 153.594C168.33 154.518 169.079 155.268 170.004 155.268Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M188.802 92.8379C192.944 92.8379 196.302 89.48 196.302 85.3379C196.302 81.1958 192.944 77.8379 188.802 77.8379C184.66 77.8379 181.302 81.1958 181.302 85.3379C181.302 89.48 184.66 92.8379 188.802 92.8379Z",
    fill: "#31D490"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M188.802 93.738C187.141 93.738 185.516 93.2453 184.135 92.3223C182.754 91.3993 181.677 90.0874 181.041 88.5525C180.406 87.0176 180.239 85.3287 180.563 83.6992C180.887 82.0698 181.687 80.5731 182.862 79.3983C184.037 78.2235 185.534 77.4235 187.163 77.0994C188.793 76.7753 190.481 76.9416 192.016 77.5774C193.551 78.2132 194.863 79.2898 195.786 80.6712C196.709 82.0526 197.202 83.6766 197.202 85.338C197.202 87.5658 196.317 89.7024 194.742 91.2777C193.166 92.853 191.03 93.738 188.802 93.738ZM188.802 78.738C187.497 78.738 186.22 79.1251 185.135 79.8503C184.05 80.5755 183.204 81.6063 182.704 82.8123C182.205 84.0183 182.074 85.3453 182.329 86.6256C182.583 87.9059 183.212 89.0819 184.135 90.0049C185.058 90.9279 186.234 91.5565 187.514 91.8112C188.795 92.0658 190.122 91.9351 191.328 91.4356C192.534 90.9361 193.564 90.0901 194.29 89.0048C195.015 87.9194 195.402 86.6433 195.402 85.338C195.402 83.5876 194.707 81.9088 193.469 80.6711C192.231 79.4333 190.552 78.738 188.802 78.738Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M189.294 88.0741H189.228C189.084 88.0651 188.944 88.0211 188.82 87.9458C188.697 87.8706 188.594 87.7663 188.52 87.6421L185.628 82.8001C185.56 82.6987 185.513 82.5846 185.491 82.4646C185.468 82.3447 185.47 82.2214 185.497 82.1022C185.524 81.9831 185.574 81.8707 185.646 81.7717C185.717 81.6728 185.808 81.5894 185.913 81.5266C186.017 81.4639 186.134 81.4231 186.255 81.4068C186.376 81.3904 186.499 81.3988 186.616 81.4315C186.734 81.4642 186.844 81.5205 186.939 81.5969C187.034 81.6733 187.113 81.7683 187.17 81.8761L189.402 85.6021L195.6 77.8741C195.75 77.6879 195.967 77.5688 196.204 77.5429C196.442 77.517 196.68 77.5865 196.866 77.7361C197.052 77.8857 197.171 78.1031 197.197 78.3405C197.223 78.5779 197.154 78.8159 197.004 79.0021L189.996 87.7381C189.911 87.8421 189.804 87.9261 189.682 87.9842C189.561 88.0422 189.428 88.0729 189.294 88.0741Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M99 163.476C99 163.476 103.596 162.162 104.346 161.784C105.096 161.406 108.75 157.47 108.75 156.912C108.75 156.354 107.436 156.63 106.41 157.188C105.384 157.746 102.21 161.22 102.21 161.22L99 163.476Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0899 164.598C96.0899 164.598 102.186 161.88 102.846 161.412C103.506 160.944 106.218 158.13 106.41 157.212C106.602 156.294 104.532 156.558 103.968 156.84C103.404 157.122 100.032 160.494 99.6539 160.872C99.2759 161.25 95.4539 164.436 95.4539 164.436C95.4539 164.436 94.1999 165.066 96.0899 164.598Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0579 166.038C74.0579 166.038 80.058 159.798 81.192 159.126C82.326 158.454 95.6819 158.46 95.6819 158.46C95.6819 158.46 102.144 156.66 103.26 156.45C104.376 156.24 104.154 158.46 102.594 159.354C101.034 160.248 96.3479 164.478 94.5659 165.594C92.7839 166.71 81.4139 168.27 81.4139 168.27L75.8399 174.954L70.0439 171.39L74.0579 166.038Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6818 158.46C95.6818 158.46 98.5318 158.13 98.2498 158.97C97.9678 159.81 96.9358 161.598 94.9678 161.694L86.9038 162.066",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6818 158.46C95.6818 158.46 98.5318 158.13 98.2498 158.97C97.9678 159.81 96.9358 161.598 94.9678 161.694L86.9038 162.066",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0439 171.39C70.0439 171.39 64.9979 171 64.0019 171.6C63.0059 172.2 50.3999 186.402 50.3999 186.402L54.9479 208.242C54.7439 209.124 75.4499 187.5 78.4019 181.002C79.6739 178.194 76.6019 174.798 76.6019 174.798L70.0439 171.39Z",
    fill: "#70A9FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M71.55 165.666L81.57 172.638L77.322 177.714L67.71 171.18L71.55 165.666Z",
    fill: "#5D94E7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M120.534 130.403L67.7988 133.01L69.0875 159.078L121.823 156.472L120.534 130.403Z",
    fill: "#9F807C",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6621 133.923L69.3845 134.429L69.6431 139.679L79.9206 139.173L79.6621 133.923Z",
    fill: "#FFE0A4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M120.537 130.4L109.75 130.933L111.039 157.001L121.826 156.468L120.537 130.4Z",
    fill: "#B87771",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M120.522 130.416C120.522 130.416 124.722 133.326 126.39 136.314",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M124.896 134.322L124.734 140.79L129.708 146.76L136.674 140.628L131.7 134.49L124.896 134.322Z",
    fill: "#FFC655",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7998 119.4V125.1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7998 169.5V175.2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8999 128.1L64.7999 131.1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0998 148.2L58.7998 148.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9999 163.2L65.0999 167.1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M123.9 159L128.7 163.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M122.7 127.8L126.6 123.3",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M138.138 247.782H78.4141V252.6H138.138V247.782Z",
    fill: "#888888",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5261 246.162H79.3921V247.71H83.5261V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8601 246.162H84.7261V247.71H88.8601V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2002 246.162H90.0662V247.71H94.2002V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5341 246.162H95.4001V247.71H99.5341V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M104.874 246.162H100.74V247.71H104.874V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M110.208 246.162H106.074V247.71H110.208V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M115.548 246.162H111.414V247.71H115.548V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M120.882 246.162H116.748V247.71H120.882V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M126.222 246.162H122.088V247.71H126.222V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M131.556 246.162H127.422V247.71H131.556V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M136.896 246.162H132.762V247.71H136.896V246.162Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4001 252.6H39.3421C38.5511 252.597 37.7703 252.421 37.055 252.083C36.3396 251.746 35.7072 251.255 35.2024 250.646C34.6976 250.037 34.3327 249.325 34.1336 248.559C33.9345 247.794 33.906 246.994 34.0501 246.216L45.6901 184.734L48.5281 185.274L36.8881 246.75C36.8191 247.111 36.8307 247.482 36.9222 247.838C37.0137 248.194 37.1828 248.525 37.4174 248.808C37.6519 249.09 37.9462 249.318 38.2789 249.473C38.6117 249.629 38.9748 249.709 39.3421 249.708H65.4001V252.6Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7881 181.476L42.6121 182.76L45.8221 199.776L50.9641 198.816L46.7881 181.476Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4001 234.864L36.9961 136.854L38.4841 137.778C40.1249 138.796 41.5396 140.139 42.6407 141.726C43.7418 143.312 44.506 145.107 44.8861 147L59.8501 222.6C60.2774 224.772 60.1878 227.013 59.5885 229.144C58.9892 231.274 57.8969 233.234 56.4001 234.864Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M270.396 252.6H278.4",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3081 252.6H264.234",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersuccess);
export default __webpack_public_path__ + "static/media/ordersuccess.f25d50cc2524bf03c8c343e56a3fe4a9.svg";
export { ForwardRef as ReactComponent };